
import { memo } from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const FetchDocumentConfig = memo(({ data, onChange }: any) => {

    return (
        <div className="space-y-6">
            <div className="space-y-2">
                <Label>Document Type</Label>
                <Select
                    value={data.documentType || 'Referral'}
                    onValueChange={(v) => onChange('documentType', v)}
                >
                    <SelectTrigger className="w-full text-xs">
                        <SelectValue placeholder="Select Type" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="Referral">Referral Scan</SelectItem>
                        <SelectItem value="LabResult">Lab Result</SelectItem>
                        <SelectItem value="PriorAuth">Prior Authorization</SelectItem>
                        <SelectItem value="IdCard">Patient ID</SelectItem>
                        <SelectItem value="ClaimForm">Claim Form</SelectItem>
                        <SelectItem value="Invoice">Invoice</SelectItem>
                    </SelectContent>
                </Select>
                <p className="text-[10px] text-gray-400">
                    The system will search the DMS for this document type related to the context (Patient/Claim).
                </p>
            </div>
        </div>
    );
});
